import React from "react";

type Props = React.ButtonHTMLAttributes<HTMLButtonElement> & {
  label: string;
  active?: boolean;
};

export default function IconButton({
  label,
  active,
  className = "",
  children,
  ...rest
}: Props) {
  return (
    <button
      {...rest}
      aria-label={label}
      title={label}
      className={[
        "inline-flex items-center justify-center w-10 h-10",
        "rounded-control border transition-colors",
        active
          ? "bg-primary/15 text-primary border-primary/45"
          : "bg-white/5 text-white/85 border-white/15 hover:bg-white/10",
        "disabled:opacity-40 disabled:cursor-not-allowed",
        "focus:outline-none focus-visible:ring-2 focus-visible:ring-primary/60",
        className,
      ].join(" ")}
    >
      {children}
    </button>
  );
}
